module.exports = __webpack_public_path__ + "img/슬레이어.20b0c0cf.png";